module.exports = [{
      plugin: require('../.yarn/unplugged/gatsby-virtual-70bec844dc/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
